import { render, staticRenderFns } from "./CatalogFilterMobileTitle.vue?vue&type=template&id=490090a2&scoped=true&"
import script from "./CatalogFilterMobileTitle.vue?vue&type=script&lang=js&"
export * from "./CatalogFilterMobileTitle.vue?vue&type=script&lang=js&"
import style0 from "./CatalogFilterMobileTitle.vue?vue&type=style&index=0&id=490090a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490090a2",
  null
  
)

export default component.exports